import { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import apiUrl from '../../../config/api';

const useArchiveSubjects = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const authHeaders = useMemo(() => ({
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }), [token]);
  const [archives, setArchives] = useState([]);
  const [subjectsByArchiveId, setSubjectsByArchiveId] = useState({});
  const [isLoadingArchives, setIsLoadingArchives] = useState(false);
  const [loadingSubjectArchiveId, setLoadingSubjectArchiveId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      return;
    }

    setIsLoadingArchives(true);
    setError('');

    axios.post(`${apiUrl}/getArchives`, {}, { headers: authHeaders })
      .then((response) => {
        setArchives(Array.isArray(response.data) ? response.data : []);
      })
      .catch((requestError) => {
        setError(requestError.response?.data?.message || requestError.message);
      })
      .finally(() => {
        setIsLoadingArchives(false);
      });
  }, [authHeaders, token]);

  const loadSubjects = useCallback(async (archiveId) => {
    if (!archiveId || subjectsByArchiveId[archiveId]) {
      return subjectsByArchiveId[archiveId] || [];
    }

    setLoadingSubjectArchiveId(archiveId);
    setError('');

    try {
      const response = await axios.post(`${apiUrl}/getSubjects`, { archiveId }, { headers: authHeaders });
      const subjects = Array.isArray(response.data) ? response.data : [];

      setSubjectsByArchiveId((currentSubjects) => ({
        ...currentSubjects,
        [archiveId]: subjects,
      }));

      return subjects;
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message);
      return [];
    } finally {
      setLoadingSubjectArchiveId('');
    }
  }, [authHeaders, subjectsByArchiveId]);

  return {
    token,
    authHeaders,
    archives,
    subjectsByArchiveId,
    isLoadingArchives,
    loadingSubjectArchiveId,
    error,
    setError,
    loadSubjects,
  };
};

export default useArchiveSubjects;
